<template>
  <div>
    <rvdashboard/>
  </div>
</template>
<script>
import rvdashboard from "@/components/rvdashboard.vue";
export default {
  name: "Pannaryapp",
  components: {
    rvdashboard
  },
  created() {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>




// WEBPACK FOOTER //
// src/components/Pannaryapp.vue